import { Divider, PopoverArrow, PopoverBody, Box, Text, Flex, Button, VStack, HStack } from '@chakra-ui/react';
import { tooltipContentStyles } from '../BundleSecondaryOption/BundleSecondaryOption.styles';
import Image from '@legacy-vfuk/core-image';
import ContentfulRichText from '@uk-source-web/contentful-rich-text';
import { RichText } from '@/types/Product.types';
import { ImageWithDescription } from '@/components/pageBuilder/Elements/SWTariffCard/SWTariffCard.types';
import { getImage, getSrc } from 'gatsby-plugin-image';
import {
  TPTooltipTitle,
  TPTooltipDescription,
  TPTooltipProductName,
  TPTooltipSubDescription,
  TPTooltipSubtitle,
} from './CustomTooltip.styles';

export interface ITenantPortingTooltip {
  tooltipText: RichText;
  title?: string;
  productName?: string;
  mainProductIcon?: ImageWithDescription;
  subtitle?: string;
  description?: string;
  subDescription?: string;
  productIconTitle?: string;
  productsIcons?: ImageWithDescription[];
}
//tooltipDetails
export const TenantPortingTooltip = ({
  tooltipText,
  title,
  productName,
  subtitle,
  description,
  subDescription,
  productIconTitle,
  productsIcons,
  mainProductIcon,
}: ITenantPortingTooltip) => {
  const mainProductIconSrc = mainProductIcon?.itemIcon
    ? getSrc(mainProductIcon?.itemIcon) ?? getImage(mainProductIcon?.itemIcon)?.placeholder?.fallback
    : undefined;
  const productsIconsSrc = productsIcons?.map(
    ({ itemIcon }) => getSrc(itemIcon) ?? getImage(itemIcon)?.placeholder?.fallback
  );

  return (
    <>
      <PopoverArrow />
      <PopoverBody {...tooltipContentStyles}>
        <ContentfulRichText document={JSON.parse(tooltipText.raw)} />
      </PopoverBody>
      <Divider width={'90%'} my={2} borderColor="#979797" />

      {/* Product Information Section */}
      <VStack align="start" spacing={2} w="100%" pt={2} p={4}>
        <TPTooltipTitle>{title || 'Product Information'}</TPTooltipTitle>
        <HStack spacing={2}>
          <Image
            alt=""
            sm={{
              src: mainProductIconSrc ?? '',
              width: '48px',
              height: '48px',
            }}
          />
          <TPTooltipProductName>{productName || 'Microsoft'}</TPTooltipProductName>
        </HStack>
        <Box>
          <TPTooltipSubtitle>{subtitle || 'Subscription Product'}</TPTooltipSubtitle>
          <TPTooltipDescription>{description || 'Microsoft 365 Apps for enterprise'}</TPTooltipDescription>
        </Box>
        <TPTooltipSubDescription>{subDescription || 'Belongs to: name@emailaddress.com'}</TPTooltipSubDescription>
        <TPTooltipSubDescription>{productIconTitle || 'This product contains'}</TPTooltipSubDescription>
        <HStack spacing={1} pt={1} w="100%" justifyContent="center">
          {productsIconsSrc?.map((src, index) => (
            <Image
              alt=""
              sm={{
                src: src ?? '',
                width: '32px',
                height: '32px',
              }}
            />
          ))}
        </HStack>
      </VStack>
    </>
  );
};
